module.exports = __webpack_public_path__ + "static/media/bifoldDoor270.80162a2f.png";